import styles from './icon.module.scss';

interface GitHubIconProps {
  fillColor?: string;
}

export const GitHubIcon = ({ fillColor = '#f1f1f1' }: GitHubIconProps) => {
  return (
    <svg
      className={styles.githubIcon}
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="57"
      viewBox="0 0 56 57"
      fill="none"
    >
      <g clipPath="url(#clip0_89_156)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28 0.425293C43.4644 0.425293 56 13.2771 56 29.1335C56 41.8147 47.9864 52.5724 36.8676 56.372C35.448 56.6548 34.944 55.7582 34.944 54.9938C34.944 54.0474 34.9776 50.9563 34.9776 47.1147C34.9776 44.4379 34.0816 42.6909 33.0764 41.8005C39.312 41.0893 45.864 38.6615 45.864 27.6351C45.864 24.4991 44.7776 21.94 42.98 19.9296C43.2712 19.2044 44.2316 16.2844 42.7056 12.3308C42.7056 12.3308 40.3592 11.5615 35.014 15.2743C32.7768 14.6387 30.38 14.3189 28 14.3077C25.62 14.3189 23.226 14.6387 20.9916 15.2743C15.6408 11.5615 13.2888 12.3308 13.2888 12.3308C11.7684 16.2844 12.7288 19.2044 13.0172 19.9296C11.228 21.94 10.1332 24.4991 10.1332 27.6351C10.1332 38.6335 16.6712 41.0985 22.89 41.8237C22.0892 42.5405 21.364 43.805 21.112 45.6614C19.516 46.395 15.4616 47.6646 12.964 43.2771C12.964 43.2771 11.4828 40.5187 8.6716 40.3171C8.6716 40.3171 5.9416 40.2808 8.4812 42.0616C8.4812 42.0616 10.3152 42.9436 11.5892 46.2616C11.5892 46.2616 13.2328 51.3855 21.0224 49.6495C21.0364 52.0491 21.0616 54.3106 21.0616 54.9938C21.0616 55.7526 20.5464 56.6407 19.1492 56.3747C8.02199 52.5807 0 41.8175 0 29.1335C0 13.2771 12.5384 0.425293 28 0.425293Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_89_156">
          <rect width="56" height="56" fill={fillColor} transform="translate(0 0.425293)" />
        </clipPath>
      </defs>
    </svg>
  );
};
